import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-cancel-eligibility-step-modal',
    templateUrl: './cancel-eligibility-step-modal.component.html',
    styleUrls: ['./cancel-eligibility-step-modal.component.scss'],
    standalone: false
})
export class CancelEligibilityStepModalComponent extends CfetBaseComponent {

  returnURL = '';
  @Input() openModal: string;
  @Output() closeModal = new EventEmitter<any>();

  constructor() { super(); }

  closeApplication (event, modalAction: string) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeModal.emit('modalClose');
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        // Get the Return URL from the session storage
        this.returnURL = JSON.parse(sessionStorage.getItem('returnUrl'));
        // checking if the return url has ? or not
        if (this.returnURL && this.returnURL.indexOf('?') === -1) {
          // If the return URL doesn't have ? then append it with the return url
          this.redirectUrl(encodeURIComponent(this.returnURL + '?fnStatus=ineligible'));
        } else {
          // otherwise append & with the return url
          this.redirectUrl(encodeURIComponent(this.returnURL + '&fnStatus=ineligible'));
        }
      } else {
        // Redirect to the plp page
        const urlPlp = environment.plp_page;
        this.redirectUrl(encodeURIComponent(urlPlp + '&fnStatus=ineligible'));
      }
      sessionStorage.clear();
    }
  }

  redirectUrl (url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }

  isEncoded (url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }

  close (event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click'
      || event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeModal.emit('modalClose');
    }
  }
}
